'use client';

import React from 'react';
import ReactPlayer from 'react-player';

interface VideoPlayerProps {
  url: string;
  width?: string | number;
  height?: string | number;
}

export default function VideoPlayer({
  url,
  width = '100%',
  height = '500px',
}: VideoPlayerProps) {
  return <ReactPlayer src={url} controls width={width} height={height} />;
}
